<template>
  <div>
    <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
        <router-link :to="{ path: '/leader'}">
          <button type="submit" class="btn btn-info btn-sm active px-3 mr-3">İçerik</button>
        </router-link>
        <router-link :to="{ path: '/leader/gallery'}">
          <button type="submit" class="btn btn-warning btn-sm mr-3 px-3">Fotogaleri</button>
        </router-link>
        <router-link :to="{ path: '/leader/pressgallery'}">
          <button type="submit" class="btn btn-danger btn-sm mr-3 px-3">Yazılı Basın</button>
        </router-link>
        <router-link :to="{ path: '/leader/articles'}">
          <button type="submit" class="btn btn-success btn-sm mr-3 px-3">Başkanın Yazıları</button>
        </router-link>
        <router-link :to="{ path: '/leader/articlesorder'}">
          <button type="submit" class="btn btn-primary btn-sm mr-3 px-3">Yazı Sıralama</button>
        </router-link>
        <router-link :to="{ path: '/leader/digital-press'}">
          <button type="submit" class="btn btn-secondary btn-sm  mr-3 px-3">Dijital Basın</button>
        </router-link>
        <router-link :to="{ path: '/leader/digital-press-order'}">
          <button type="submit" class="btn btn-info btn-sm mr-3 px-3">Dijital Basın Sıralama</button>
        </router-link>
      </div>
      <span></span>
    </div>
    <card>
      <form class="w-100" @submit="saveImage">
        <div v-if="!err">

        <h1 class="h4 mt-0 d-flex justify-content-between">
          <span>Başkanın Bölümü</span>

          <button type="submit" class="btn btn-info btn-sm btn-fill">Kaydet</button>
        </h1>
        <div class="row">
          <div
            v-bind:class="{ 'col-md-6': !item.meta.isimage,'col-md-12':item.meta.isimage}"
            v-for="item in  settings"
            :key="item.id"
          >
            <div class="d-flex flex-column">
              <label :class="item.meta.labelClass" :id="item.meta.id" :for="item.name">
                <span v-if="!item.meta.isimage" class="title">{{item.meta.title}}</span>
                <span v-if="item.meta.subTitle">({{item.meta.subTitle}})</span>
              </label>
              <input
                v-if="!item.meta.isimage"
                :type="item.meta.type"
                :disabled="item.meta.disabled"
                :class="item.meta.class"
                v-model="item.data"
                :id="item.name"
                class="form-control"
              />
            </div>
            <div class="row text-right" v-if="item.meta.isimage">
              <div class="col-8 col-md-8 m-3 d-flex align-items-center justify-content-between">
                <div class="d-flex flex-column align-items-center">
                  <span class="title">{{item.meta.title}}</span>
                  <img
                    v-if="image.cropped"
                    v-bind:src="image.cropped"
                    class="img-fluid mt-4 d-block border border-secondary p-2"
                  />
                  <img
                    v-if="!image.cropped"
                    :src="mediaURL() + item.data"
                    class="img-fluid mt-4 d-block border border-secondary p-2"
                  />
                </div>
                <div class="d-flex flex-column">
                  <small class="d-block w-100 mb-3">400 x 450 pixel</small>

                  <b-btn v-b-modal.croppieModal v-on:click="initiateCroppie('main')">Resim Seç</b-btn>
                </div>
              </div>
              <b-modal id="croppieModal" hide-footer size="lg" title="Resim Seç">
                <input name="myFile" id="myImage" class="m-3" type="file" @change="bind()" />
                <vue-croppie
                  :enable-resize="false"
                  :viewport="{width: 300, height: 338, type: 'suare'}"
                  :boundary="{width: 360, height: 405}"
                  ref="main"
                  :enableOrientation="true"
                  @result="result"
                ></vue-croppie>
                <b-btn class="mt-3" variant="danger btn-fill" @click="hideCroppieModal()">İptal</b-btn>
                <b-btn class="mt-3" variant="success btn-fill float-right" @click="crop()">Kaydet</b-btn>
              </b-modal>
            </div>
          </div>
        </div>
                </div>
<div v-if="err">
{{err}}
</div>
      </form>
    </card>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";

export default {
  data: function() {
    return {
      settings: null,
      imageIndex: -1,
      image: {
        cropped: null
      },
      err:null
    };
  },
  components: {
    Card
  },
  methods: {
    addImageToEditor: function(i) {
      this.$http
        .post("/api/images/upload/" + this.post.url + "leader-image", {
          cropped: i
        })
        .then(
          response => {
            this.content.content =
              this.content.content +
              '<img src="' +
              this.mediaURL() +
              response.body.Data.Response.name +
              '" width="100%" alt="' +
              this.post.url +
              '" />';
          },
          e => {
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            this.toggleLoader();
          }
        );
    },
    getSettings: function() {
      this.toggleLoader();
      this.$http.get("/api/settings/get-leader-settings/").then(
        response => {
          this.settings = response.body;
          for (var i = 0; i < this.settings.length; i++) {
            this.settings[i].meta = JSON.parse(this.settings[i].meta);
          }

          this.toggleLoader();
        },
        er => {
            this.toggleLoader();
            if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
        }
      );
    },
    submit: function() {
      event.preventDefault();
      this.$http.post("/api/settings/update-bulk-leader/", this.settings).then(
        response => {
          this.notifier("top", "right", "success", "Başarıyla güncellendi");
          this.getSettings();
        },
        e => {
                                if(!e.body.Error){
            this.notifier(
              "top",
              "right",
              "danger",
              "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
            );
            }else{
            this.notifier(
              "top",
              "right",
              "danger",
              e.body.Error
            );
            }
        }
      );
    },
    getImageName: function() {
      for (var i = 0; i < this.settings.length; i++) {
        if (this.settings[i].meta.isimage) {
          this.imageIndex = i;
          break;
        }
      }
    },
    saveImage: function() {
      if (!this.image.cropped) return this.submit();
      this.getImageName();
      this.$http
        .post(
          "/api/images/upload/" + this.settings[this.imageIndex].name,
          this.image
        )
        .then(
          response => {
            this.settings[this.imageIndex].data =
              response.body.Data.Response.name;
            this.image.cropped = null;
            this.submit();
          },
          e => {
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            this.toggleLoader();
          }
        );
    },
    initiateCroppie(type) {
      this.croppieType = type;
    },
    bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        var refz = this.$refs;
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        oFReader.onload = function(oFREvent) {
          refz.main[0].bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop() {
      var dis = this;
      var wdt = 400;
      var hgt = 450;
      if (this.croppieType === "tinymce") {
        wdt = 400;
        hgt = 450;
      }
      return new Promise(resolve => {
        let options = {
          format: "jpeg",
          size: {
            width: wdt,
            height: hgt
          },

          quality: 1
        };
        dis.$refs.main[0].result(options, output => {
          if (this.croppieType === "main") {
            dis.image.cropped = output;
          } else if (this.croppieType === "slider") {
            dis.sliderImage.cropped = output;
            dis.sliderImageLoaded = true;
          } else if (this.croppieType === "tinymce") {
            this.notifier(
              "top",
              "right",
              "warning",
              "Lütfen resim yükleninceye kadar bekleyin."
            );
            this.addImageToEditor(output);
          }
          this.hideCroppieModal();
          dis.$refs.main[0].refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result(output) {
      return output;
    },
    changePosition: function(e) {
      this.position.lat = e.lat();
      this.position.lng = e.lng();
      for (var i = 0; i < this.settings.length; i++) {
        if (this.settings[i].name === "latitude") {
          this.settings[i].data = e.lat();
        }
        if (this.settings[i].name === "longitude") {
          this.settings[i].data = e.lng();
        }
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getSettings();
    });
  }
};
</script>
<style>
div#croppieModal {
    display: flex!important;
    align-items: center;
    justify-content: center;
    height: 100%!important;
}

div#croppieModal .modal-dialog {
    transform: none!important;
}
.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: #007bff !important;
}
.nav-pills:focus {
  outline: none;
}
.nav-pills a {
  color: #000;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  color: #fff;
}
.nav-item {
  margin-bottom: 5px;
}
.menu-item:hover {
  cursor: move;
}
.panel-map {
  width: 100%;
  height: 2.7rem !important;
  margin-bottom: 1rem;
}
label .title {
  text-transform: capitalize;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/LeaderModules/Index.vue